/* Shop by Category JS */
(function(){
  const CLASS_SECTION = 'shop-by-category';

  function initSection(section){
    if(!section || section.dataset.sbcatInit) return; section.dataset.sbcatInit='1';
    const cards = section.querySelectorAll('.shop-by-category__card');
    const preloadList=[];
    cards.forEach(card=>{ const h=card.dataset.hoverSrc; if(h){ preloadList.push(h);} });
    preload(preloadList);
  }
  function preload(urls){ urls.forEach(u=>{ const i=new Image(); i.decoding='async'; i.loading='eager'; i.src=u; }); }
  function scan(){ document.querySelectorAll('.'+CLASS_SECTION).forEach(initSection); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',scan); } else { scan(); }
  document.addEventListener('shopify:section:load', e=>{ const s=e.target.querySelector('.'+CLASS_SECTION); if(s) initSection(s); });
})();
